import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=c72cc7f2&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=js&"
export * from "./Train.vue?vue&type=script&lang=js&"
import style0 from "./Train.vue?vue&type=style&index=0&id=c72cc7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72cc7f2",
  null
  
)

export default component.exports